import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * 찜 탭 - 상품 화면 진입 시 1회 발화.
 * StrictMode / 리렌더로 이펙트가 재실행돼도 ref 가드로 중복 발화 방지.
 * SCREEN 은 AnalyticsContext 에서 자동 주입.
 */
export const useLogViewLikedGoods = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current) return;
    loggedRef.current = true;
    logAnalyticsEvent({ name: 'VIEW_LIKED_GOODS' });
  }, [logAnalyticsEvent]);
};
